<template>
  <div :class="`border_${mode}`" class="dynamic-bullet_container">
    <div :class="`back_${mode}`" class="dynamic-bullet_container_back"></div>
    <img :src="avatar" class="dynamic-bullet_container_avatar" />
    <div :class="`nickName_${mode}`" class="dynamic-bullet_container_nickName">
      {{ name }}
    </div>
    <div :class="`font_color_${mode}`" class="dynamic-bullet_container_text">
      {{ time }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    avatar: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      a: 1
    }
  },
  beforeMount() {}
}
</script>

<style lang="scss" scoped>
.dynamic-bullet_container_back {
  content: '';
  z-index: 20;
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  width: 100%;

  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  max-width: 400px;
  backdrop-filter: blur(3px);
}
.dynamic-bullet_container {
  z-index: 40;
  display: flex;
  justify-content: center;
  color: white;
  position: absolute;
  border-radius: 40px;
  border-right: 0px;
  max-width: 400px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  height: 40px;
  > div {
    z-index: 30;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &_nickName {
    margin-left: 50px;
    margin-right: 10px;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;

    flex: 1;
    -webkit-line-clamp: 2; /* 设置超出多少行隐藏 */
    -webkit-box-orient: vertical;
    /* 设置 display 为 -webkit-box 或者 -webkit-inline-box 时为隐藏状态 */
    display: -webkit-inline-box;
  }
  &_text {
    display: block !important;
    line-height: 38px;
    font-size: 16px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 20px;
  }
  &_avatar {
    border: 1px solid rgba(239, 241, 242, 0.31);
    z-index: 30;
    position: absolute;
    left: -1px;
    border-radius: 40px;
    width: 39px;
    height: 39px;
  }
}

.back_dark {
  background: linear-gradient(270deg, #000000 0%, rgba(77, 69, 46, 0.8) 100%);
}

.back_normal {
  background: #ffffff;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.border_dark {
  border: 1px solid rgba(255, 201, 76, 0.25);
  border-right: 0px;
}
.border_normal {
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
}
.nickName_normal {
  color: #9b9b9b;
  opacity: 0.65;
}
.nickName_dark {
  color: #ffffff;
  opacity: 0.65;
}
.font_color_dark {
  color: white;
}
.font_color_normal {
  color: #444;
}
</style>
